'use es6';

import { connect } from 'react-redux';
import { useEffect } from 'react';
import { track } from 'MeetingsLib/tracking/UsageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { getMeetingSourceFromLocation } from 'MeetingsLib/utils/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RescheduleHeader = ({
  eventDetails,
  isRescheduling
}) => {
  useEffect(() => {
    track('meetingEventInteraction', {
      action: 'viewed reschedule',
      source: getMeetingSourceFromLocation()
    });
  }, []);
  if (!isRescheduling) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("h2", {
      className: "text-center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reschedule.header"
      })
    }), eventDetails && /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "reschedule.description",
      options: {
        meetingDateTime: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: eventDetails.startTime,
          format: "LLLL"
        })
      }
    })]
  });
};
export default connect(state => ({
  eventDetails: state.eventDetails,
  isRescheduling: state.isRescheduling
}))(RescheduleHeader);